'use client';

/**
 * Mobile-only back affordance for the collapsed master-detail views (Users,
 * Permissions): a ghost "< {label}" button rendered above the detail panel.
 * Callers gate it behind their own `isMobile` check — this component renders
 * wherever it is mounted.
 */

import { Icon } from '@iconify/react';

import { COLORS } from '@/shared/theme/pencil-tokens';

export function MobileBackBar({
  label,
  onBack,
}: {
  label: string;
  onBack: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onBack}
      aria-label={`Back to ${label}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        alignSelf: 'flex-start',
        gap: 4,
        minHeight: 44,
        padding: '0 12px 0 4px',
        background: 'none',
        border: 'none',
        borderRadius: 8,
        cursor: 'pointer',
        color: COLORS.accentBlue,
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      <Icon icon="lucide:chevron-left" width={20} />
      {label}
    </button>
  );
}
